import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface PendingChangesAwareComponent {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class PendingChangesGuard implements CanDeactivate<PendingChangesAwareComponent> {
  canDeactivate(component: PendingChangesAwareComponent): boolean | Observable<boolean> {
    if (!component || typeof component.canDeactivate !== 'function') {
      return true;
    }
    return component.canDeactivate();
  }
}
